module.exports = __webpack_public_path__ + "static/media/bgimg.cdfcc6f6.jpg";